export default __webpack_public_path__ + "static/media/AntyLucy_10.0b20126f.png";